export enum TranslationLinkRel {
	TRANSLATE = 'translate',
	TRANSLATE_EINTRAGUNG = 'translateEintragung',
}
